import { secureGet } from "config/encryption_decryption/get_post_encryptDecrypt";

export const exportHistory = async (panelListId: number) => {
  return secureGet("/api/survey/getSurveyHistory/export", { panelListId });
};